module.exports = __webpack_public_path__ + "static/SoleilLight-1efd72eae5e7a935e933e74617e71fb4.otf";